import {
  takeEvery, call, put, select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  getAgentTipsRequest,
  getAgentTipsFail,
  getAgentTipsDebuggingInfo,
} from '../../slices/intelligence';
import formatRoomsRequest from '../../../helpers/formatRoomsRequest';

const queryString = require('query-string');

function* getAgentTipsWorker({
  payload: {
    cruiseDepartDate,
    cruiseReturnDate,
    cruiseItineraryId,
    cruiseDepartureCityId,
    doRunTipsInParallel,
  },
}) {
  try {
    const searchObj = yield select((state) => state.tripSearch.searchObj.cruise);
    const staterooms = yield select((state) => state.tripSearch.searchObj.staterooms);
    const {
      value: flightOriginGeoIndex,
      featureClass: flightOriginFeatureClass,
    } = searchObj.filters.origin || {};

    const { cabinType } = searchObj.filters;

    const {
      fromDate, toDate,
    } = searchObj;

    const request = {
      flightOriginGeoIndex,
      flightOriginFeatureClass,
      cruiseDepartureFromDate: fromDate,
      cruiseDepartureToDate: toDate,
      selectedCruiseDepartureDate: cruiseDepartDate,
      selectedCruiseReturnDate: cruiseReturnDate,
      cruiseDepartureCityId,
      cruiseItineraryId,
      cabinType,
      doRunTipsInParallel,
      ...formatRoomsRequest(staterooms),
    };

    const qs = queryString.stringify({
      ...request,
    }, { skipNull: true });

    const url = `/intelligence?${qs}`;
    const config = {
      method: 'get',
      url,
      params: request,
    };
    const { data } = yield call(axios, config);

    if (data && data.debuggingInfo) {
      yield put(getAgentTipsDebuggingInfo({
        cruiseItineraryId,
        flightOriginGeoIndex,
        debuggingInfo: data.debuggingInfo,
      }));
    }
    if (!data) {
      yield put(getAgentTipsFail({
        cruiseItineraryId,
        error: 'Tips not found!',
      }));
    }
  } catch (error) {
    yield put(getAgentTipsFail({
      cruiseItineraryId,
      error: 'Tips not found!',
    }));
  }
}

function* getAgentTipsWatcher() {
  yield takeEvery(getAgentTipsRequest.toString(), getAgentTipsWorker);
}

export default getAgentTipsWatcher;
